/**
 * @deprecated - use string literal, e.g. `"success"` instead of `AlertType.SUCCESS`
 */
export const AlertType = {
  SUCCESS: "success",
  ERROR: "error",
  WARNING: "warning",
} as const;

export type AlertTypeOption = "success" | "error" | "warning";

export type AlertButtons = { label: string; action: () => void }[];

export interface AlertArguments {
  message: string;
  buttons?: AlertButtons;
  alertType?: AlertTypeOption;
  response?: { data: { [key: string]: unknown; message?: string } };
}

export const GENERATE_ALERT = "GENERATE_ALERT";
export interface GenerateAlertAction {
  type: typeof GENERATE_ALERT;
  alertType?: AlertTypeOption;
  message: string;
  buttons?: AlertButtons;
}

export const DISMISS_ALERT = "DISMISS_ALERT";
export interface DismissAlertAction {
  type: typeof DISMISS_ALERT;
}

export type AlertAction = GenerateAlertAction | DismissAlertAction;
